import React from 'react';
export default function ChartLegend(_ref) {
  let {
    colors,
    titles,
    chartLegendColor = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, `.piechart-legend-circle {
          padding: 5px;
          border-radius: 50%;
          max-width: 5px;
          max-height: 5px;
        }`), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center",
    style: chartLegendColor
  }, titles.map((title, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "d-flex align-items-center me-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "piechart-legend-circle me-1",
    style: {
      backgroundColor: colors[index]
    }
  }), /*#__PURE__*/React.createElement("i", {
    className: "bi bi-circle-fill fs-7 me-2"
  }), title))));
}